import { Alert, Col, Container, Form, Row, Spinner, Stack } from 'react-bootstrap'
import { FormFeedback } from '../../components/Form/FormFeedback'
import { Controller, useForm } from 'react-hook-form'
import React, { useCallback, useEffect } from 'react'
import { Button } from '../../components/Button/Button'
import { useGetMeQuery, useSaveUserByIdMutation } from '../../store/user/user'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { MissingScopeAction } from '../../components/ScopedBlock/models'
import { ScopedBlock } from '../../components/ScopedBlock/ScopedBlock'
import { EventFilters } from './EventFilters/EventFilters'

export const MeetingAssistantTab = () => {
  const accountId = useAppSelector(selectAccountId)

  interface FormValues {
    meetingAssistantName: string
  }

  const { data: currentUser, isFetching: isFetchingUser } = useGetMeQuery({ accountId: accountId })

  const defaultValues: FormValues = {
    meetingAssistantName: ``,
  }

  const { control, handleSubmit, setValue } = useForm<FormValues>({ defaultValues })
  const resetForm = useCallback(() => {
    setValue('meetingAssistantName', currentUser?.integrationConfig?.botName || `${currentUser?.me}'s Assistant`)
  }, [currentUser?.integrationConfig?.botName, currentUser?.me, setValue])

  const [saveUserById, { isLoading: isUpdating }] = useSaveUserByIdMutation()

  const onSubmit = (data: FormValues) => {
    if (currentUser) {
      saveUserById({
        accountId,
        userId: currentUser.id,
        userData: {
          integrationConfig: {
            botName: data.meetingAssistantName,
          },
        },
      })
    }
  }

  useEffect(() => {
    resetForm()
  }, [currentUser, resetForm])

  return (
    <Container className='d-flex flex-column gap-5 p-0'>
      <Row>
        <Col>
          <Container className='d-flex flex-column gap-2 p-0'>
            <Row>
              <Col>
                <h4>Assistant Name</h4>
              </Col>
            </Row>
            {isFetchingUser ? (
              <Spinner />
            ) : (
              <>
                <Row>
                  <Col md={6}>
                    <Row>
                      <Col>
                        <Controller
                          name='meetingAssistantName'
                          control={control}
                          render={({ field, fieldState }) => (
                            <>
                              <Form.Control {...field} type='text' placeholder={`${currentUser?.me}'s Assistant `} />
                              {fieldState.error && <FormFeedback>{fieldState.error.message}</FormFeedback>}
                            </>
                          )}
                        />
                      </Col>
                      <Col xs='auto'>
                        <Stack direction='horizontal' className='gap-3'>
                          <Button variant='secondary' onClick={() => resetForm()}>
                            Cancel
                          </Button>
                          <ScopedBlock
                            scope={{
                              scope: 'integration:update',
                              superScope: ['integration:admin'],
                            }}
                            missingScopeAction={MissingScopeAction.DISABLE}
                          >
                            <Button variant='primary' onClick={handleSubmit(onSubmit)} loading={isUpdating}>
                              Save
                            </Button>
                          </ScopedBlock>
                        </Stack>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Alert variant='warning' className='d-flex gap-3 align-items-center'>
                      <i className='bi bi-info-square zocks-text-primary consent-settings-info-square' />
                      <span className='zocks-text-gray-900'>
                        Assistant Image can be added in Compliance settings.{' '}
                        <a
                          target='_blank'
                          href='/dashboard/workspace/setup/settings/compliance#compliance-notice'
                          rel='noreferrer'
                          className='button-link-medium zocks-text-gray-900'
                        >
                          Click here to set it up.
                        </a>
                      </span>
                    </Alert>
                  </Col>
                </Row>
              </>
            )}
          </Container>
        </Col>
      </Row>
      <Row>
        <Col>
          <EventFilters />
        </Col>
      </Row>
    </Container>
  )
}
